import '@fortawesome/fontawesome-free/css/all.css';
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

import colors from 'vuetify/lib/util/colors';

export default new Vuetify({
    icons: {
        iconfont: 'fa',
    },
    theme: {
        dark: false,
        options: {
            customProperties: true,
        },
        themes: {
            light: {
                // base: colors.orange.darken3,
                primary: "#44E0B2",
                secondary: "#DEE0E6",
                success: colors.lightGreen,
                error: colors.red.accent3,
                icon: colors.brown,
                accepted: colors.lightBlue,
                process: colors.amber,
                pending: colors.grey,
                payer: colors.green,
                text: colors.black,
                background: "linear-gradient(151deg, rgba(78,246,162,1) 0%, rgba(0,235,181,1) 11%, rgba(47,187,244,1) 47%);",
                alternativeBackground: "#dee0e6",
                switch: "#3D434F",
                label: "#797979",
                btnSucces: "#44E0B2",
                btnNo: "#636363"
            },
            dark: {
                // base: colors.orange.darken3,
                primary: "#0092B9",
                secondary: "#636363",
                error: colors.red.accent3,
                success: colors.lightGreen,
                icon: colors.orange,
                accepted: colors.lightBlue,
                process: colors.amber,
                pending: colors.grey,
                payer: colors.green,
                text: colors.white,
                background: "#3d434f",
                alternativeBackground: "#606572",
                switch: "#43E1B2",
                label: "#C1C3C7",
                btnSucces: "#44E0B2",
                btnNo: "#636363"
            },
        },
    },
});
